import uniqueId from 'lodash-es/uniqueId'
import { Error, Loader } from '../../common'
import { selectSelectedApprovalRequest } from '../../../selectors/approvalRequests'
import { isEmpty } from '../../../utils/common'
import { selectExamWindowRefData } from '../../../selectors/examWindows'
import { sortColumnByKey } from '../../../utils/sort'

const mapStateToProps = (state, ownProps) => {
  const { panelIsOpen } = ownProps
  const selectedApprovalRequest = selectSelectedApprovalRequest(state)
  const { examsStarted, examsNotStarted, fetching, error } = selectedApprovalRequest
  const examWindowRefData = selectExamWindowRefData(state)

  return {
    examsStarted: sortColumnByKey(examsStarted, 'studentLastName', 'asc'),
    examsNotStarted: sortColumnByKey(examsNotStarted, 'studentLastName', 'asc'),
    fetching,
    error,
    panelIsOpen,
    examWindowRefData,
  }
}

const StudentExamsTable = connect(mapStateToProps)(({ students, examWindowRefData }) => {
  return (
    <table className="table table-condensed cb-no-table-border">
      <thead>
        <tr>
          <th>Student Name</th>
          <th>Previous Admin</th>
        </tr>
      </thead>
      <tbody>
        {students.map(({ studentLastName, studentFirstName, previousOrderedExamDate }) => (
          <tr key={uniqueId()}>
            <td>
              {studentLastName}, {studentFirstName}
            </td>
            <td>{examWindowRefData[previousOrderedExamDate]?.displayName}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
})

const StudentExams = ({ students, title }) => {
  if (!isEmpty(students)) {
    return (
      <>
        <h5>{title}</h5>
        <StudentExamsTable students={students} />
      </>
    )
  }

  return null
}

const Students = connect(mapStateToProps)(({ examsStarted, examsNotStarted, fetching, error }) => {
  if (error) {
    return <Error message={error} />
  }

  if (fetching) {
    return <Loader />
  }

  return (
    <div className="row">
      <div className="col-xs-12" style={{ paddingBottom: '1.5em' }}>
        <StudentExams title="Students Who Started Exam" students={examsStarted} />
        <StudentExams title="Students Who Did Not Start Exam" students={examsNotStarted} />
      </div>
    </div>
  )
})

export default Students
